<template>
  <vs-row v-if="data">
    <vs-col>
      <vs-row vs-justify="center" vs-align="center">
        <vs-col vs-w="4">
          <vs-row>
            <vs-col :vs-w="6" class="p-3">
              <referrals-statistics-card :data="data" :color="'primary'" :icon="'MailIcon'"
                                         :label="$t('reports.global.referrals_sent')"/>
            </vs-col>

            <vs-col :vs-w="6" class="p-3">
              <referrals-accepted-card :data="data" :color="'#19aef6'" :icon="'MailIcon'"
                                       :label="$t('reports.global.referrals_sent')"/>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col :vs-w="6" class="p-3" v-if="hasProgram('MENTAL_FITNESS')">
              <referrals-statistics-card :data="data" :program="'MENTAL_FITNESS'"
                                         :color="'success'"
                                         :icon="'CloudIcon'"
                                         :label="$t('reports.global.programs.MENTAL_FITNESS')"/>
            </vs-col>

            <vs-col :vs-w="6" class="p-3" v-if="hasProgram('MENTAL_FITNESS')">
              <referrals-accepted-card :data="data" :program="'MENTAL_FITNESS'"
                                       :color="'#28C76F'"
                                       :icon="'CloudIcon'"
                                       :label="$t('reports.global.programs.MENTAL_FITNESS')"/>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col :vs-w="6" class="p-3" v-if="hasProgram('RTH_MENTAL')">
              <referrals-statistics-card :data="data" :program="'RTH_MENTAL'"
                                         :color="'warning'"
                                         :icon="'CloudDrizzleIcon'"
                                         :label="$t('reports.global.programs.RTH_MENTAL')"/>
            </vs-col>
            <vs-col :vs-w="6" class="p-3" v-if="hasProgram('RTH_MENTAL')">
              <referrals-accepted-card :data="data" :program="'RTH_MENTAL'"
                                       :color="'#FF9F43'"
                                       :icon="'CloudDrizzleIcon'"
                                       :label="$t('reports.global.programs.RTH_MENTAL')"/>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col :vs-w="6" class="p-3" v-if="hasProgram('RTH_PHYSICAL')">
              <referrals-statistics-card :data="data" :program="'RTH_PHYSICAL'"
                                         :color="'danger'"
                                         :icon="'CloudLightningIcon'"
                                         :label="$t('reports.global.programs.RTH_PHYSICAL')"/>
            </vs-col>
            <vs-col :vs-w="6" class="p-3" v-if="hasProgram('RTH_PHYSICAL')">
              <referrals-accepted-card :data="data" :program="'RTH_PHYSICAL'"
                                       :color="'#EA5455'"
                                       :icon="'CloudLightningIcon'"
                                       :label="$t('reports.global.programs.RTH_PHYSICAL')"/>
            </vs-col>
          </vs-row>
        </vs-col>
        <vs-col vs-w="8">
          <vs-row>
            <vs-col :vs-w="12" class="p-3">
              <referrals-histogram-card :height="height" :data="data"/>
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>
    </vs-col>
  </vs-row>
</template>

<script>

import ReferralsStatisticsCard from './graphs/referrals-statistics-card';
import ReferralsAcceptedCard from './graphs/referrals-accepted-card';
import ReferralsHistogramCard from './graphs/referrals-histogram-card';
import {ResourceImpl} from 'hal-client';
import Vue from 'vue';

export default {
  name: 'analysis-referrals',
  components: {
    ReferralsHistogramCard,
    ReferralsAcceptedCard,
    ReferralsStatisticsCard
  },
  props: {
    resource: ResourceImpl,
    date: String,
    filters: Object,
    bus: Vue
  },
  data () {
    return {data: null};
  },
  computed: {
    programs () {
      const root = this.data.analysis.find(n => n.name === 'ROOT');
      const allTime = root.nested.find(n => n.name === 'ALL_TIME');
      const programs = allTime.nested.find(n => n.name === 'PROGRAMS');
      return programs.buckets.map(b => b.key);
    },
    height () {
      return 150 + (150 * this.programs.length);
    }
  },
  created () {
    this.bus.$on('refresh', this.refresh);
  },
  mounted () {
    this.refresh();
  },
  destroyed () {
    this.bus.$off('refresh', this.refresh);
  },
  methods: {
    hasProgram (program) {
      return this.programs.indexOf(program) >= 0;
    },
    refresh () {
      if (this.resource.$has('referrals')) {
        const params = {
          ...this.filters,
          date: this.date
        };
        this.resource.$request().$get('referrals', params).then(res => {
          this.data = res;
        });
      }
    }
  }
};
</script>
